module.exports = __webpack_public_path__ + "img/logo-sc-mobile.ff7547f9.png";